import DoctorPatients from '../../doctor/patients/Patients';

const HospitalPatients = () => {
  return <DoctorPatients />;
};

export default HospitalPatients;
